(()=>{'use strict';
function init(){
 document.querySelectorAll('[data-d12-story]').forEach(film=>{
  if(film.dataset.ready)return;film.dataset.ready='true';
  if(matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  let frame=0;const update=()=>{frame=0;const r=film.getBoundingClientRect();const h=innerHeight;const p=Math.max(0,Math.min(2,(-r.top+h*.12)/Math.max(1,(r.height-h)/2)));film.style.setProperty('--story-progress',p.toFixed(3));};
  const schedule=()=>{if(!frame)frame=requestAnimationFrame(update);};
  document.addEventListener('scroll',schedule,{passive:true,capture:true});window.addEventListener('resize',schedule,{passive:true});update();
 });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();document.addEventListener('shopify:section:load',init);
})();
